import QRCode from 'qrcode';

// Mã đơn: tiền tố chữ (HD, TH... cấu hình trong AppSetting) + số.
const ORDER_CODE_PATTERN = /^[A-Z]{1,5}\d{3,}$/;

/** Trang xử lý nhanh của đơn — đích của mã QR in trên bill/tem. */
export const orderQuickPath = (orderCode: string): string => `/o/${encodeURIComponent(orderCode)}`;

export const orderQrUrl = (orderCode: string, origin: string = window.location.origin): string =>
  `${origin}${orderQuickPath(orderCode)}`;

const safeDecode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/** Đọc mã đơn từ nội dung quét được: link .../o/HD00226 hoặc chính mã HD00226. */
export const parseOrderCode = (scanned: string): string | null => {
  const text = scanned.trim();
  const fromUrl = text.match(/\/o\/([^/?#\s]+)/i);
  const candidate = safeDecode(fromUrl ? fromUrl[1] : text)
    .trim()
    .toUpperCase();
  return ORDER_CODE_PATTERN.test(candidate) ? candidate : null;
};

export const toQrDataUrl = (text: string, size = 240): Promise<string> =>
  QRCode.toDataURL(text, { width: size, margin: 1, errorCorrectionLevel: 'M' });
